import axios from 'axios'
import qs from 'qs'

// Vue.http.options.xhr = {withCredentials: true}
// Vue.http.options.emulateJSON = true

let http = axios.create({
  withCredentials: true
})

export default {
  install (Vue, options) {
    let api = options.api

    Vue.prototype.$task = function (task = null) {
      let editable = ['status']

      let defaultSave = false
      let saveQueue = []

      let all = function () {
        let params = {
          function: 'tasks',
          method: 'getlist'
        }

        return new Promise((resolve, reject) => {
          http.post(api, qs.stringify(params)).then(response => {
            resolve(response.data.Data.rows)
          })
        })
      }

      let set = function (key, value) {
        if (editable.indexOf(key) === -1) {
          return false
        }

        if (typeof saveExceptions[key] !== 'undefined') {
          saveQueue.push(key)
        } else {
          defaultSave = true
        }

        task[key] = value
        return this
      }

      let saveStatus = function () {
        let params = {
          function: 'tasks',
          method: 'onoff',
          taskpk: task.pk,
          newstatus: task.status
        }

        http.post(api, qs.stringify(params)).then(response => {
          return response.data.Data.rows
        })
      }

      let save = function () {
        return new Promise((resolve, reject) => {
          for (let i = 0; saveQueue.length > i; i++) {
            saveExceptions[saveQueue[i]]()
          }
          if (defaultSave) {
            // http.post(api + query, qs.stringify(params))
          }
          resolve()
        })
      }

      let run = function () {
        let params = {
          function: 'tasks',
          method: 'runnow',
          taskpk: task.pk
        }

        return new Promise((resolve, reject) => {
          http.post(api, qs.stringify(params)).then(response => {
            let status = response.statusText
            if (status !== 'OK') {
              reject()
              return false
            }
            resolve(response)
          })
        })
      }

      let saveExceptions = {
        'status': saveStatus
      }

      let log = function () {
        return new Promise((resolve, reject) => {
          let params = {
            function: 'tasks',
            method: 'gettasklog',
            taskpk: task.pk
          }

          http.post(api, qs.stringify(params)).then(response => {
            resolve(response.data.Data.rows)
          })
        })
      }

      return {
        all,
        run,
        set,
        save,
        log
      }
    }

    Vue.prototype.$log = function (type = null, item = null) {
      let editable = ['status']

      let defaultSave = false
      let saveQueue = []

      let types = {
        error: {
          function: 'errorlog',
          all: {
            method: 'getlist'
          },
          count: {
            method: 'geterrorcount'
          }
        },
        task: {
          function: 'tasks',
          all: {
            method: 'gethistory'
          },
          find: {
            method: 'gettasklog'
          }
        }
      }

      let all = function () {
        let params = types[type].all
        params.function = types[type].function

        return new Promise((resolve, reject) => {
          http.post(api, qs.stringify(params)).then(response => {
            resolve(response.data.Data.rows)
          })
        })
      }

      let detail = function () {
        return new Promise((resolve, reject) => {
          let params = {
            function: 'errorlog',
            method: 'geterrorlist',
            errortitle: item.title
          }

          http.post(api, qs.stringify(params)).then(response => {
            resolve(response.data.Data.rows)
          })
        })
      }
      let find = function (pk = null) {
        return new Promise((resolve, reject) => {
          if (typeof types[type].find === 'undefined') {
            reject('Unable to perform a lookup by PK on this log type')
          }
          if (pk === null) {
            reject('Find: must provide PK')
          }
          let params = {
            function: types[type].function,
            method: types[type].find.method,
            taskpk: pk
          }

          http.post(api, qs.stringify(params)).then(response => {
            resolve(response.data.Data.rows)
          })
        })
      }

      let set = function (key, value) {
        if (editable.indexOf(key) === -1) {
          return false
        }

        if (typeof saveExceptions[key] !== 'undefined') {
          saveQueue.push(key)
        } else {
          defaultSave = true
        }

        item[key] = value
        return this
      }

      let save = function () {
        return new Promise((resolve, reject) => {
          for (let i = 0; saveQueue.length > i; i++) {
            saveExceptions[saveQueue[i]]()
          }
          if (defaultSave) {
            // This isn't used
            // http.post(api, qs.stringify(params))
          }
          resolve()
        })
      }

      let saveStatus = function () {
        let params = {
          function: 'errorlog',
          method: 'updatestatus',
          pk: item.pk,
          newstatus: item.status
        }
        http.post(api, qs.stringify(params)).then(response => {
          return response.data.Data.rows
        })
      }

      let count = function () {
        return new Promise((resolve, reject) => {
          if (typeof types[type].count === 'undefined') {
            reject('Unable to perform a lookup by PK on this log type')
          }

          let params = types[type].count
          params.function = types[type].function

          http.post(api, qs.stringify(params)).then(response => {
            if (typeof response.data.Data.rows[0] === 'undefined') {
              resolve(0)
              return
            }
            resolve(response.data.Data.rows[0].count)
          })
        })
      }

      let saveExceptions = {
        'status': saveStatus
      }

      return {
        all,
        find,
        detail,
        set,
        save,
        count
      }
    }
  }

}




// WEBPACK FOOTER //
// ./src/adminconsole-sdk.js